import React from "react";
import { Select, MenuItem, InputLabel, FormControl } from "@mui/material";

const Language = ({
  languageName,
  handleLanguageChange,
  languageList,
  languageId,
}) => {
  return (
    <div>
      <FormControl fullWidth size="small">
        <InputLabel id="demo-simple-select-label">Language</InputLabel>
        <Select
          labelId="demo-simple-select-label"
          id="demo-simple-select"
          value={languageName}
          label="Language"
          onChange={handleLanguageChange}
        >
          {languageList?.map((el) => (
            <MenuItem key={el?.languageId} value={`${el.languageName}`}>
              {el.languageName}
            </MenuItem>
          ))}
        </Select>
      </FormControl>
    </div>
  );
};

export default Language;
